
import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { OPCIONES_GOOGLE_MAPS } from '../../mapas/opcionesGoogleMaps';
import { useMemo } from "react";
import axios from 'axios';

import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

import { BlockUI } from 'primereact/blockui';


import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from "primereact/checkbox";
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup';

import { useLocalState } from '../../util/useLocalStorage';
import { FilterMatchMode } from 'primereact/api';

import { InputSwitch } from 'primereact/inputswitch';
import { ProgressSpinner } from 'primereact/progressspinner';
import { UsuarioService } from '../../services/Usuario/UsuarioService';
import { OperadorService } from '../../services/Operador/OperadorService';

import { sonidoPara, reproducir } from '../Alertas/sonidoAlerta';
import { BASE_URL } from '../../services/ApiService/ApiConfig';

const Operador = () => {

    const { isLoaded } = useJsApiLoader(OPCIONES_GOOGLE_MAPS);


    let _monitoreoDet = {
        monitoreoDetId: 0,
        activo: true,
        estado: 'Activo',
        fechaFinEvento: '',
        fechaIngreso: '',
        fechaInicioEvento: '',
        observacion: '',
        origenId: '',
        latitud: '',
        longitud: '',
        tipo: {},
        evento: {},
        novedad: {},
        monitoreoCab: {},
        monitoreoDetProceso: {},
        bitacoraDet: {},
        viaje: {},
        usuario: {},
        informacionGeneral: {}

    }


    const usuarioService = new UsuarioService();
    const operadorService = new OperadorService();

    const [monitoreoDets, setMonitoreoDets] = useState(null);
    const [listaNovedad, setListaNovedad] = useState(null);
    const [monitoreoDetDialog, setMonitoreoDetDialog] = useState(false);
    const [mapaDialog, setMapaDialog] = useState(false);

    const [mensajeProceso, setMensajeProceso] = useState("");
    const [habilitarGuardar, setHabilitarGuardar] = useState(true);


    const [monitoreoDet, setMonitoreoDet] = useState(_monitoreoDet);
    const [selectedMonitoreoDet, setSelectedMonitoreoDets] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const [latitud, setLatitud] = useState("");
    const [longitud, setLongitud] = useState("");

    const toast = useRef(null);
    const dt = useRef(null);
    const [blocked, setBlocked] = useState(false);
    const [blockedDataTable, setBlockedDataTable] = useState(false);

    const [numeroAlertasSeleccionadas, setNumeroAlertasSeleccionadas] = useState(10);
    const [tipoAlertaSeleccionada, setTipoAlertaSeleccionada] = useState(null);

    const [habilitarBoton, setHabilitarBoton] = useState(true);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });


    const numeroAlertas = [
        { name: '10', value: 10 },
        { name: '20', value: 20 },
        { name: '30', value: 30 },
        { name: '40', value: 40 },

    ];
    const tipoAlerta = [
        { name: 'Alarma', value: "Alarma" },
        { name: 'Emergencia', value: "Emergencia" },

    ];

    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");

    /**Headers Token */
    const config = {
        headers: {
            'Content-Type': "application/json",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: `Bearer ${jwt}`
        }
    }


    /**Usuario */
    const [usuario, setUsuario] = useState("");
    const [username, setUsername] = useLocalState("", "username");

    const [activarInterval, setActivarInterval] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    /**Color de input según estado */
    const [backgroundEstadoCandado, setBackgroundEstadoCandado] = useState("");
    const [colorEstadoCandado, setColorEstadoCandado] = useState("");

    /**Size Del Datatbale */
    const [size, setSize] = useState("small");
    const [checkedMasivo, setCheckedMasivo] = useState(false);

    useEffect(() => {
        if (activarInterval) {
            const interval = setInterval(() => {
                console.log(numeroAlertasSeleccionadas);
                setBlockedDataTable(true);
                operadorService.getListaMonitoreoDetsXUsuarioYnumeroAlertas(username, numeroAlertasSeleccionadas).then(data => {
                    if (data.length !== 0) {
                        play(data);
                    }
                    let _monitoreoDetList = [];

                    data.forEach(d => {

                        let _monitoreDetTmp = { ..._monitoreoDet };
                        _monitoreDetTmp.evento = {};
                        _monitoreDetTmp.tipo = {};
                        _monitoreDetTmp.fechaIngreso = d.fechaIngreso;
                        _monitoreDetTmp.fechaInicioEvento = d.fechaInicioEvento;
                        _monitoreDetTmp.fechaFinEvento = d.fechaFinEvento;
                        _monitoreDetTmp.tipo.nombre = d.tipo.nombre;
                        _monitoreDetTmp.evento.nombre = d.evento.nombre;
                        _monitoreDetTmp.estado = d.estado;
                        _monitoreDetTmp.puntoCercano = d.puntoCercano;
                        _monitoreDetTmp.monitoreoDetId = d.monitoreoDetId;
                        _monitoreDetTmp.monitoreoDetProceso = d.monitoreoDetProceso


                        _monitoreDetTmp.longitud = d.longitud;
                        _monitoreDetTmp.latitud = d.latitud;

                        if (d.tipo.nombre == "BITACORA") {
                            _monitoreDetTmp.bitacoraDet = {};
                            _monitoreDetTmp.bitacoraDet = d.bitacoraDet;
                            _monitoreDetTmp.informacionGeneral = {};
                            _monitoreDetTmp.informacionGeneral.booking = d.bitacoraDet?.booking;
                            _monitoreDetTmp.informacionGeneral.contenedor = d.bitacoraDet?.contenedor;
                            _monitoreDetTmp.informacionGeneral.dispositivo = d.bitacoraDet?.dispositivo?.nombre;
                            _monitoreDetTmp.informacionGeneral.placa = d.bitacoraDet?.vehiculoPlaca;
                            _monitoreDetTmp.informacionGeneral.empresaTransporte = d.bitacoraDet?.empresaTransporte?.nombre;
                            _monitoreDetTmp.informacionGeneral.usuario = d.bitacoraDet?.bitacoraCab?.usuario?.nombre;
                            _monitoreDetTmp.informacionGeneral.destinoCodigo = d.bitacoraDet?.destinoCodigo;
                            _monitoreDetTmp.informacionGeneral.destinoNombre = d.bitacoraDet?.destinoNombre;
                            _monitoreDetTmp.informacionGeneral.choferNombre = d.bitacoraDet?.conductorNombre;

                        } else {
                            _monitoreDetTmp.viaje = {};
                            _monitoreDetTmp.viaje = d.viaje;
                            _monitoreDetTmp.informacionGeneral = {};
                            if (d.viaje) {
                                _monitoreDetTmp.informacionGeneral.booking = d.viaje.booking;
                                _monitoreDetTmp.informacionGeneral.contenedor = d.viaje.contenedor;
                                _monitoreDetTmp.informacionGeneral.dispositivo = d.viaje.dispositivo?.nombre;
                                if (d.viaje.empresa == null) {
                                    _monitoreDetTmp.informacionGeneral.empresaTransporte = "";
                                } else {
                                    _monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                                }
                                //_monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                                _monitoreDetTmp.informacionGeneral.usuario = d.viaje.usuario?.username;
                                _monitoreDetTmp.informacionGeneral.placa = d.viaje.dispositivo?.nombre;
                                if (d.viaje.ruta == null) {
                                    _monitoreDetTmp.informacionGeneral.rutaCodigo = "";
                                } else {
                                    _monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                                }
                                //_monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                                _monitoreDetTmp.informacionGeneral.choferNombre = (d.viaje.chofer?.nombre ?? "") + "\n" + (d.viaje.chofer?.telefono ?? "");
                            } else {
                                _monitoreDetTmp.informacionGeneral.dispositivo = d.monitoreoCab?.dispositivo?.nombre ? d.monitoreoCab.dispositivo.nombre : ""
                            }
                        }

                        _monitoreoDetList.push(_monitoreDetTmp);
                    });

                    setMonitoreoDets(_monitoreoDetList);
                    setBlockedDataTable(false);

                });
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [activarInterval, numeroAlertasSeleccionadas]);

    useEffect(() => { usuarioService.getUsuario(username).then(data => setUsuario(data)); }, []);

    useEffect(() => {
        setBlockedDataTable(true);

        operadorService.getListaMonitoreoDetsXUsuarioYnumeroAlertas(username, numeroAlertasSeleccionadas).then(data => {
            //console.log(data);
            if (data.length !== 0) {
                play(data);
            }
            let _monitoreoDetList = [];

            data.forEach(d => {

                let _monitoreDetTmp = { ..._monitoreoDet };
                _monitoreDetTmp.evento = {};
                _monitoreDetTmp.tipo = {};
                _monitoreDetTmp.fechaIngreso = d.fechaIngreso;
                _monitoreDetTmp.fechaInicioEvento = d.fechaInicioEvento;
                _monitoreDetTmp.fechaFinEvento = d.fechaFinEvento;
                _monitoreDetTmp.tipo.nombre = d.tipo.nombre;
                _monitoreDetTmp.evento.nombre = d.evento.nombre;
                _monitoreDetTmp.estado = d.estado;
                _monitoreDetTmp.puntoCercano = d.puntoCercano;
                _monitoreDetTmp.monitoreoDetId = d.monitoreoDetId;
                _monitoreDetTmp.monitoreoDetProceso = d.monitoreoDetProceso


                _monitoreDetTmp.longitud = d.longitud;
                _monitoreDetTmp.latitud = d.latitud;

                if (d.tipo.nombre == "BITACORA") {
                    _monitoreDetTmp.bitacoraDet = {};
                    _monitoreDetTmp.bitacoraDet = d.bitacoraDet;
                    _monitoreDetTmp.informacionGeneral = {};
                    _monitoreDetTmp.informacionGeneral.booking = d.bitacoraDet?.booking;
                    _monitoreDetTmp.informacionGeneral.contenedor = d.bitacoraDet?.contenedor;
                    _monitoreDetTmp.informacionGeneral.dispositivo = d.bitacoraDet?.dispositivo?.nombre;
                    _monitoreDetTmp.informacionGeneral.placa = d.bitacoraDet?.vehiculoPlaca;
                    _monitoreDetTmp.informacionGeneral.empresaTransporte = d.bitacoraDet?.empresaTransporte?.nombre;
                    _monitoreDetTmp.informacionGeneral.usuario = d.bitacoraDet?.bitacoraCab?.usuario?.nombre;
                    _monitoreDetTmp.informacionGeneral.destinoCodigo = d.bitacoraDet?.destinoCodigo;
                    _monitoreDetTmp.informacionGeneral.destinoNombre = d.bitacoraDet?.destinoNombre;
                    _monitoreDetTmp.informacionGeneral.choferNombre = d.bitacoraDet?.conductorNombre;


                } else {
                    _monitoreDetTmp.viaje = {};
                    _monitoreDetTmp.viaje = d.viaje;
                    _monitoreDetTmp.informacionGeneral = {};
                    if (d.viaje) {
                        _monitoreDetTmp.informacionGeneral.booking = d.viaje.booking;
                        _monitoreDetTmp.informacionGeneral.contenedor = d.viaje.contenedor;
                        _monitoreDetTmp.informacionGeneral.dispositivo = d.viaje.dispositivo?.nombre;
                        if (d.viaje.empresa == null) {
                            _monitoreDetTmp.informacionGeneral.empresaTransporte = "";
                        } else {
                            _monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                        }
                        //_monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                        _monitoreDetTmp.informacionGeneral.usuario = d.viaje.usuario?.username;
                        _monitoreDetTmp.informacionGeneral.placa = d.viaje.dispositivo?.nombre;
                        if (d.viaje.ruta == null) {
                            _monitoreDetTmp.informacionGeneral.rutaCodigo = "";
                        } else {
                            _monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                        }
                        //_monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                        _monitoreDetTmp.informacionGeneral.choferNombre = (d.viaje.chofer?.nombre ?? "") + "\n" + (d.viaje.chofer?.telefono ?? "");
                    } else {
                        _monitoreDetTmp.informacionGeneral.dispositivo = d.monitoreoCab?.dispositivo?.nombre ? d.monitoreoCab.dispositivo.nombre : ""
                    }

                }

                _monitoreoDetList.push(_monitoreDetTmp);
            });

            setMonitoreoDets(_monitoreoDetList);
            setBlockedDataTable(false);

        })
    }, []);

    useEffect(() => { operadorService.getListaNovedad().then(data => { setListaNovedad(data); }); }, []);



    async function guardarMonitoreoDet(monitoreoDet) {
        let monitoreoDetSinInfoGeneral = { ...monitoreoDet };
        delete monitoreoDetSinInfoGeneral.informacionGeneral;

        return await axios.put(`${BASE_URL}/monitoreo/monitoreo-det`,
            { data: monitoreoDetSinInfoGeneral },
            config
        ).then(res => {
            let _monitoreDetTmp = { ...monitoreoDet };
            let _monitoreoDets = [...monitoreoDets];

            let _monitoreoDetFiltrado = _monitoreoDets.filter((_monitoreoDet) => _monitoreoDet.monitoreoDetId !== _monitoreDetTmp.monitoreoDetId);
            setMonitoreoDets(_monitoreoDetFiltrado);
            setCheckedMasivo(false);
            showSuccess();
            hideDialog();
        });
    }


    async function guardarMonitoreoDetMasivo(monitoreoDet) {
        let monitoreoDetSinInfoGeneral = { ...monitoreoDet };
        delete monitoreoDetSinInfoGeneral.informacionGeneral;

        return await axios.put(`${BASE_URL}/monitoreo/monitoreo-det-masivo`, { data: monitoreoDetSinInfoGeneral }, config).then(res => {
            // res.data;

            setCheckedMasivo(false);
            showSuccess();
            hideDialog();
            buscarXnumeroAlerta();
        }
        )
    }

    const guardar = () => {

        if (checkedMasivo == true) {
            guardarMonitoreoDetMasivo(monitoreoDet);

        } else {
            guardarMonitoreoDet(monitoreoDet);
        }

    }

    // Con un pánico VIP en la lista suena la sirena VIP; si no, el sonido general de siempre.
    function play(data) {
        reproducir(sonidoPara(data));
    }

    const buscarXnumeroAlerta = () => {
        setActivarInterval(false);
        setBlockedDataTable(true);
        console.log("Buscar Activado");
        operadorService.getListaMonitoreoDetsXUsuarioYnumeroAlertas(username, numeroAlertasSeleccionadas).then(data => {
            if (data.length !== 0) {
                play(data);
            }
            let _monitoreoDetList = [];

            data.forEach(d => {

                let _monitoreDetTmp = { ..._monitoreoDet };
                _monitoreDetTmp.evento = {};
                _monitoreDetTmp.tipo = {};
                _monitoreDetTmp.fechaIngreso = d.fechaIngreso;
                _monitoreDetTmp.fechaInicioEvento = d.fechaInicioEvento;
                _monitoreDetTmp.fechaFinEvento = d.fechaFinEvento;
                _monitoreDetTmp.tipo.nombre = d.tipo.nombre;
                _monitoreDetTmp.evento.nombre = d.evento.nombre;
                _monitoreDetTmp.estado = d.estado;
                _monitoreDetTmp.puntoCercano = d.puntoCercano;
                _monitoreDetTmp.monitoreoDetId = d.monitoreoDetId;
                _monitoreDetTmp.monitoreoDetProceso = d.monitoreoDetProceso;

                _monitoreDetTmp.longitud = d.longitud;
                _monitoreDetTmp.latitud = d.latitud;


                if (d.tipo.nombre == "BITACORA") {
                    _monitoreDetTmp.bitacoraDet = {};
                    _monitoreDetTmp.bitacoraDet = d.bitacoraDet;
                    _monitoreDetTmp.informacionGeneral = {};
                    _monitoreDetTmp.informacionGeneral.booking = d.bitacoraDet?.booking;
                    _monitoreDetTmp.informacionGeneral.contenedor = d.bitacoraDet?.contenedor;
                    _monitoreDetTmp.informacionGeneral.dispositivo = d.bitacoraDet?.dispositivo?.nombre;
                    _monitoreDetTmp.informacionGeneral.placa = d.bitacoraDet?.vehiculoPlaca;
                    _monitoreDetTmp.informacionGeneral.empresaTransporte = d.bitacoraDet?.empresaTransporte?.nombre;
                    _monitoreDetTmp.informacionGeneral.usuario = d.bitacoraDet?.bitacoraCab?.usuario?.nombre;
                    _monitoreDetTmp.informacionGeneral.destinoCodigo = d.bitacoraDet?.destinoCodigo;
                    _monitoreDetTmp.informacionGeneral.destinoNombre = d.bitacoraDet?.destinoNombre;
                    _monitoreDetTmp.informacionGeneral.choferNombre = d.bitacoraDet?.conductorNombre;


                } else {
                    _monitoreDetTmp.viaje = {};
                    _monitoreDetTmp.viaje = d.viaje;
                    _monitoreDetTmp.informacionGeneral = {};
                    if (d.viaje) {
                        _monitoreDetTmp.informacionGeneral.booking = d.viaje.booking;
                        _monitoreDetTmp.informacionGeneral.contenedor = d.viaje.contenedor;
                        _monitoreDetTmp.informacionGeneral.dispositivo = d.viaje.dispositivo?.nombre;
                        if (d.viaje.empresa == null) {
                            _monitoreDetTmp.informacionGeneral.empresaTransporte = "";
                        } else {
                            _monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                        }
                        //_monitoreDetTmp.informacionGeneral.empresaTransporte = d.viaje.empresa.nombre;
                        _monitoreDetTmp.informacionGeneral.usuario = d.viaje.usuario?.username;
                        _monitoreDetTmp.informacionGeneral.placa = d.viaje.dispositivo?.nombre;
                        if (d.viaje.ruta == null) {
                            _monitoreDetTmp.informacionGeneral.rutaCodigo = "";
                        } else {
                            _monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                        }
                        //_monitoreDetTmp.informacionGeneral.rutaCodigo = d.viaje.ruta.codigo;
                        _monitoreDetTmp.informacionGeneral.choferNombre = (d.viaje.chofer?.nombre ?? "") + "\n" + (d.viaje.chofer?.telefono ?? "");
                    } else {
                        _monitoreDetTmp.informacionGeneral.dispositivo = d.monitoreoCab?.dispositivo?.nombre ? d.monitoreoCab.dispositivo.nombre : ""
                    }

                }

                _monitoreoDetList.push(_monitoreDetTmp);
            });

            setMonitoreoDets(_monitoreoDetList);

        }).then(() => setActivarInterval(true)).then(() => setBlockedDataTable(false));

    }

    const showSuccess = () => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Monitoreo se ha Guardado', life: 3000 });
    }

    async function getMensajeEstadoProceso() {
        const identificador = monitoreoDet.bitacoraDet?.dispositivo?.identificador;
        const destinoCodigo = monitoreoDet.bitacoraDet?.destinoCodigo;
        if (!identificador || !destinoCodigo) {
            setMensajeProceso("No se pudo verificar (faltan datos de dispositivo/destino). Puede guardar la novedad igual.");
            // Tambien se guarda: "no se pudo verificar" es informacion, y es
            // distinto de no haber intentado.
            setMonitoreoDet((prev) => ({ ...prev,
                verificacionMensaje: "No se pudo verificar: faltan datos de dispositivo o destino",
                verificacionOk: false }));
            setHabilitarGuardar(false);   // desbloquea Save: permite atender aunque no se pueda verificar
            return;
        }
        setBlocked(true);

        return await axios.get(`${BASE_URL}/traccar/validar/tarjeta/dispositivo/${identificador}/ubicacion/${destinoCodigo}`,
            config
        ).then(res => {
            setMensajeProceso(res.data.mensaje);
            // El resultado se guarda con la alerta: antes vivia solo aca y se
            // perdia al cerrar el dialogo, asi que quien revisaba despues no
            // podia saber si el operador habia verificado.
            const verde = res.data.mensaje === "TARJETA ASIGNADA CORRECTAMENTE";
            setMonitoreoDet((prev) => ({ ...prev,
                verificacionMensaje: res.data.mensaje, verificacionOk: verde }));
            if (res.data.mensaje === "TARJETA ASIGNADA CORRECTAMENTE") {
                setBackgroundEstadoCandado("green");
                setColorEstadoCandado("white");
                setHabilitarGuardar(false);
            }
            else {
                setBackgroundEstadoCandado("red");
                setColorEstadoCandado("white");
                setHabilitarGuardar(false)
            }
            setBlocked(false)
        });
    }

    const hideDialog = () => {
        setSubmitted(false);
        setMonitoreoDetDialog(false);
        setHabilitarGuardar(true);
        setMensajeProceso("");
        setBackgroundEstadoCandado("");
        setColorEstadoCandado("");
    }

    const hideDialogMap = () => {

        setMapaDialog(false)
    }

    const formatearFecha = (fecha, formato = 'yyyy-mm-dd hh:mm:ss') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'dd-mm-yyyy': return [day, month, year].join('-');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');

        }
    }

    const editMonitoreoDet = (monitoreoDet) => {
        setActivarInterval(false);
        setMonitoreoDet({ ...monitoreoDet });
        console.log(monitoreoDet);
        setMonitoreoDetDialog(true);
    }



    const verMapa = (monitoreoDet) => {
        setLatitud("");
        setLongitud("");
        setActivarInterval(false);
        setMonitoreoDet({ ...monitoreoDet });
        console.log(monitoreoDet);
        setMapaDialog(true);
        setLatitud(monitoreoDet.latitud);
        setLongitud(monitoreoDet.longitud);
        // center(monitoreoDet.latitud, monitoreoDet.longitud);

    }

    const center = { lat: parseFloat(latitud), lng: parseFloat(longitud) };




    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _monitoreoDet = { ...monitoreoDet };

        let _monitoreoDetProceso = _monitoreoDet[`${name}`];
        _monitoreoDet[`${name}`] = val;
        _monitoreoDet.monitoreoDetProceso.monitoreoDetProcesoId = 0;
        _monitoreoDet.monitoreoDetProceso.usuario = usuario;
        if (val.nombre === 'TARJETA ASIGNADA') {
            setHabilitarBoton(false);
            setHabilitarGuardar(true);
        } else {
            setHabilitarBoton(true);
            setHabilitarGuardar(false);
        }
        setMonitoreoDet(_monitoreoDet);
    }

    const onChangeNumeroTarjetasSeleccionadas = (value) => {

        setNumeroAlertasSeleccionadas(value);

    }

    const onInputChangeNovedad = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _monitoreoDet = { ...monitoreoDet };
        _monitoreoDet.novedad = val;
        _monitoreoDet.monitoreoDetProceso.monitoreoDetProcesoId = 0;
        _monitoreoDet.monitoreoDetProceso.usuario = usuario;

        if (val.nombre === 'TARJETA ASIGNADA') {
            setHabilitarBoton(false);
            setHabilitarGuardar(true);
        } else {
            setHabilitarBoton(true);
            setHabilitarGuardar(false);
        }
        setMonitoreoDet(_monitoreoDet);

    }

    const onInputChangeObservacion = (e, name) => {
        const val = (e.target && e.target.value.toUpperCase()) || '';
        let _monitoreoDet = { ...monitoreoDet };
        /*if (name === 'monitoreoDetProceso') {
            let _monitoreoDetProceso = _monitoreoDet[`${name}`];
            _monitoreoDetProceso.estadoProceso = val;
            _monitoreoDetProceso.monitoreoDetProcesoId = 0;
            _monitoreoDetProceso.usuario = usuario;
            _monitoreoDet[`${name}`] = _monitoreoDetProceso;
        } else {*/
        _monitoreoDet[`${name}`] = val;
        //}
        setMonitoreoDet(_monitoreoDet);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-user-edit" className="p-button-rounded p-button-success mr-2" onClick={() => editMonitoreoDet(rowData)} />
            </React.Fragment>
        );
    }

    const actionBodyTemplateMap = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-map-marker" severity="info" className="mr-2" onClick={() => verMapa(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="mx-0 my-1">Lista de Monitoreos</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} type="search" onInput={onGlobalFilterChange} placeholder="Buscar Monitoreo" />
            </span>
        </div>
    );



    const headerGroup = (
        <ColumnGroup>

            <Row>
                <Column header="Evento" alignHeader={"center"} colSpan={5} className='bg-blue-400 text-white' />
                <Column header="Información General" alignHeader={"center"} colSpan={4} className='bg-cyan-400 text-white' />
                <Column header="Destino" colSpan={3} alignHeader={"center"} className='bg-blue-400 text-white' />
                <Column header="Transporte" colSpan={4} alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Acciones" colSpan={2} alignHeader={"center"} className='bg-cyan-600 text-white' />
            </Row>

            <Row>
                <Column header="Ingreso" field="fechaIngreso" alignHeader={"center"} className='bg-blue-400 text-white' />
                <Column header="Inicio" field="fechaInicioEvento" alignHeader={"center"} className='bg-blue-400 text-white' />
                <Column header="Fin" field="fechaFinEvento" alignHeader={"center"} className='bg-blue-400 text-white' />
                <Column header="Tipo" field="tipo.nombre" alignHeader={"center"} className='bg-blue-400 text-white' />
                <Column header="Evento" field="evento.nombre" alignHeader={"center"} className='bg-blue-400 text-white' />

                <Column header="Usuario" field="informacionGeneral.usuario" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Booking" field="informacionGeneral.booking" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Contenedor" field="informacionGeneral.contenedor" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Dispositivo" field="informacionGeneral.dispositivo" alignHeader={"center"} className='bg-cyan-400 text-white' />

                <Column header="Codigo" field="informacionGeneral.destinoCodigo" align={"center"} className='bg-blue-400 text-white' ></Column>
                <Column header="Nombre" field="informacionGeneral.destinoNombre" align={"center"} className='bg-blue-400 text-white'></Column>
                <Column header="Ruta" field="informacionGeneral.rutaCodigo" align={"center"} className='bg-blue-400 text-white'></Column>

                <Column header="Vehiculo" field="informacionGeneral.placa" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Transporte" field="informacionGeneral.empresaTransporte" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="PuntoCercano" field="puntoCercano" alignHeader={"center"} className='bg-cyan-400 text-white' />
                <Column header="Chofer" field="informacionGeneral.choferNombre" alignHeader={"center"} className='bg-cyan-400 text-white' />

                <Column header="Atender" alignHeader={"center"} className='bg-cyan-600 text-white' />
                <Column header="VerMapa" alignHeader={"center"} className='bg-cyan-600 text-white' />
            </Row>

        </ColumnGroup>
    );

    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" disabled={habilitarGuardar} onChange={e => setHabilitarGuardar(e)} icon="pi pi-check" className="p-button-text" onClick={guardar} />
        </React.Fragment>
    );

    const blockuiSpinning = (
        <React.Fragment>
            <ProgressSpinner />
        </React.Fragment>
    );



    return (
        <div className="datatable-crud-demo">

            <Toast ref={toast} />

            <div className="card">


                <div className="grid">
                    <div className="flex col-12 md:col-6">

                        <div className="col-6  md:col-4">
                            <label htmlFor="input-rowclick" className="mb-3 align-self-center flex align-items-center justify-content-center">Activar Sincronización</label>
                            <div className="p-inputgroup mt-3 justify-content-center">
                                <InputSwitch inputId="input-rowclick" checked={activarInterval} onChange={(e) => setActivarInterval(e.value)} />
                            </div>
                        </div>

                        <div className="col-6  md:col-8">

                            <label htmlFor="numeroAlertas" className='mb-3'>Número de Alertas</label>
                            <div className="p-inputgroup">
                                <Dropdown id='numeroAlertas' optionLabel="name" options={numeroAlertas} value={numeroAlertasSeleccionadas}
                                    onChange={(e) => onChangeNumeroTarjetasSeleccionadas(e.value)} placeholder="Selecciona número de Alertas" filter className="w-8 md:w-10rem" />
                                <Button label='Buscar' className="p-button-success" onClick={buscarXnumeroAlerta} icon="pi pi-search" iconPos="right" />
                            </div>

                        </div>
                    </div>


                </div>

                <BlockUI blocked={blockedDataTable} template={blockuiSpinning}>


                    <DataTable ref={dt} showGridlines size={size} headerColumnGroup={headerGroup} paginator rows={20} scrollable scrollHeight="400px" value={monitoreoDets} tableStyle={{ minWidth: '250rem' }} selection={selectedMonitoreoDet} onSelectionChange={(e) => setSelectedMonitoreoDets(e.value)}
                        dataKey="id" filters={filters} header={header}
                        filterDisplay="row" globalFilterFields={['informacionGeneral.booking']} responsiveLayout="scroll"
                        sortOrder={-1}>

                        <Column field="fechaIngreso" align={"center"}  ></Column>
                        <Column field="fechaInicioEvento" align={"center"} ></Column>
                        <Column field="fechaFinEvento" align={"center"} ></Column>
                        <Column field="tipo.nombre" align={"center"} ></Column>
                        <Column field="evento.nombre" align={"center"} ></Column>

                        <Column field="informacionGeneral.usuario" align={"center"} ></Column>
                        <Column field="informacionGeneral.booking" align={"center"} ></Column>
                        <Column field="informacionGeneral.contenedor" align={"center"} ></Column>
                        <Column field="informacionGeneral.dispositivo" align={"center"} ></Column>

                        <Column field="informacionGeneral.destinoCodigo" align={"center"}  ></Column>
                        <Column field="informacionGeneral.destinoNombre" align={"center"}  ></Column>
                        <Column field="informacionGeneral.rutaCodigo" align={"center"} ></Column>

                        <Column field="informacionGeneral.placa" align={"center"} />
                        <Column field="informacionGeneral.empresaTransporte" align={"center"} ></Column>
                        <Column field="puntoCercano" align={"center"} ></Column>
                        <Column field="informacionGeneral.choferNombre" align={"center"} ></Column>

                        <Column body={actionBodyTemplate} align={"center"} exportable={false} ></Column>
                        <Column body={actionBodyTemplateMap} align={"center"} exportable={false} ></Column>
                    </DataTable>

                </BlockUI>
            </div>

            <Dialog visible={monitoreoDetDialog} style={{ width: '90vw' }} header="Detalles del Monitoreo" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                <BlockUI blocked={blocked} template={blockuiSpinning}>
                    <div className="col-12">
                        <div className="card p-fluid">
                            <div className="flex align-items-center flex-wrap card-container">
                                <div className="col-6">
                                    <label htmlFor="nombre">Tipo</label>
                                    <InputText disabled type="text" name="nombre" id="nombre" value={monitoreoDet.tipo.nombre} onChange={(e) => onInputChange(e, 'tipo')} required className={classNames({ 'p-invalid': submitted && !monitoreoDet.tipo.nombre })} />
                                </div>
                                <div className="col-6">
                                    <label htmlFor="atenderMasivamente">Atender Masivamente</label>
                                    <Checkbox className="ml-2" inputId="atenderMasivamente" onChange={e => setCheckedMasivo(e.checked)} checked={checkedMasivo}></Checkbox>
                                </div>
                            </div>

                            <div className="field col">
                                <label htmlFor="estadoProcesoList">Novedad</label>
                                <div className="p-inputgroup">
                                    <Dropdown id='estadoProcesoList' optionLabel="nombre" options={listaNovedad} value={monitoreoDet.novedad} onChange={(e) => onInputChangeNovedad(e, 'novedad')} placeholder="Seleccionar una novedad" filter className="w-full md:w-14rem" />
                                    <Button label='Verificar Estado' onClick={getMensajeEstadoProceso} disabled={habilitarBoton} className="p-button-warning" />
                                </div>
                            </div>
                            <div className="field col">
                                <InputText disabled id='mensaje' style={{ backgroundColor: backgroundEstadoCandado, color: colorEstadoCandado, opacity: 1 }} value={mensajeProceso} onChange={e => setMensajeProceso(e.value)} placeholder='Se verificará si están asignados'></InputText>
                            </div>
                            <div className="field">
                                <label htmlFor="observacion">Observacion</label>
                                <InputText type="text" name="observacion" id="observacion" value={monitoreoDet.observacion} onChange={(e) => onInputChangeObservacion(e, 'observacion')} required className={classNames({ 'p-invalid': submitted && !monitoreoDet.observacion })} />
                            </div>
                        </div>
                    </div>
                </BlockUI>
            </Dialog>

            <Dialog visible={mapaDialog} style={{ width: '85vw' }} header="Ubicación en Mapa" modal className="p-fluid" onHide={hideDialogMap} >
                <div className="col-12">
                    <GoogleMap zoom={14} center={center} mapContainerClassName="map-container">
                        <MarkerF position={center} />
                    </GoogleMap>
                </div>
            </Dialog>

        </div>
    );
}


export default Operador;
